import {handleActions} from 'redux-actions';
import * as type from './type';

export const initialState = {
    fetching: false,
    error: null,
    validationMessageList: [],
    salesOrderList: [],
    partialRefundData: {
        salesOrderId: '',
        amount: 0.00,
        numberOfProducts: 1,
        reason: '',
    }
};

export default handleActions({
    [type.CHANGE_PARTIAL_REFUND_DATA]: (state, action) => {
        const { name, value } = action.payload;
        return {
            ...state,
            partialRefundData: {
                ...state.partialRefundData,
                [name]: value,
            }
        }
    },

    [type.GET_PARTIAL_REFUND_DATA_REQUEST]: (state) => {

        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.GET_PARTIAL_REFUND_DATA_SUCCESS]: (state, action) => {
        const { partialRefundData } = action.payload

        return {
            ...state,
            partialRefundData,
            fetching: false,
            error: null,
        }
    },
    [type.GET_PARTIAL_REFUND_DATA_ERROR]: (state, action) => {
        const { error } = action.payload

        return {
            ...state,
            fetching: false,
            error,
        }
    },


    [type.GET_REFUNDABLE_SALES_ORDER_LIST_SUCCESS]: (state, action) => {
        const { salesOrderList } = action.payload

        return {
            ...state,
            salesOrderList,
        }
    },
    [type.GET_REFUNDABLE_SALES_ORDER_LIST_ERROR]: (state, action) => {
        const { error } = action.payload

        return {
            ...state,
            fetching: false,
            error,
        }
    },

    [type.SAVE_PARTIAL_REFUND_DATA_REQUEST]: (state) => {

        return {
            ...state,
            fetching: true,
            error: null,
        }
    },

    [type.SAVE_PARTIAL_REFUND_DATA_SUCCESS]: (state, action) => {

        return {
            ...state,
            fetching: false,
            error: null,
        }
    },
    [type.SAVE_PARTIAL_REFUND_DATA_ERROR]: (state, action) => {
        const { error } = action.payload

        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.ADD_VALIDATION_MESSAGE]: (state, action) => {
        const { message } = action.payload

        return {
            ...state,
            validationMessageList: [...state.validationMessageList, message],
        }
    },
    [type.CLEAR_VALIDATION_MESSAGE_LIST]: (state, action) => {
        return {
            ...state,
            validationMessageList: [],
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/partial-refund/state/reducer.js